import { KpiSkeleton } from '#core/components/dashboard/panels/kpi/KpiSkeleton.tsx';
import { KpiSchema } from '#core/components/dashboard/panels/kpi/schema.ts';

import { createGridComponent } from '../shared/helpers.ts';
import { StandardKpi } from './variants/StandardKpi.tsx';

export const Kpi = createGridComponent(
  (props) => {
    // console.log('props', { props });
    const value = props.datasets.get(props.inputDataset)?.rows.at(-1)[props.data.value];
    return (
      <StandardKpi
        label={props.title}
        unit={props.unit}
        value={value}
        // value, label, unit, trend, trendValue
      />
    );
  },
  KpiSchema,
  KpiSkeleton,
);
